<template>
  <div class="product-mushroom-page">
    <!-- 1. 顶部Banner（满屏背景图） -->
    <section class="hidden md:block banner relative w-full overflow-hidden">
      <img src="@/assets/product/Rectangle_18.png" alt="食用菌Banner" class="w-full h-full object-cover">
      <!-- 文字遮罩 -->
      <div class="absolute inset-0 bg-black/20"></div>
      <!-- 标题内容 -->
      <div class="absolute inset-0 text-center text-white z-10 top-[20%]">
        <h1 class="text-[clamp(2.5rem,5vw,4rem)] font-bold mb-3">菌中之王，鲜不过季</h1>
        <p class="text-[clamp(0.9rem,2vw,1rem)]">
          规划 100+ 智能方仓，五大品类错峰入仓、全年连续生产。
        </p>
      </div>
    </section>
    <section class="block md:hidden relative w-full overflow-hidden h-[80vh]">
      <!-- 背景图 -->
      <img src="@/assets/product/mb_bg3.png" class="absolute inset-0 w-[100%] h-[100%]" alt="" />
      <!-- 深色遮罩提升文字可读性 -->
      <div class="absolute inset-0 bg-black/15"></div>

      <div class="relative z-10 w-full pt-[20%] px-6 flex flex-col items-center text-white">
      <img src="@/assets/logo_H.png" alt="菌丰生物" class="mb-6">
        <!-- 主标题 -->
        <h2 class="text-[24px] font-bold mb-2 text-center">菌中之王，鲜不过季</h2>
        <!-- 描述文字 -->
        <p class="text-[10px] leading-6 text-center opacity-90 mb-10">
          规划 100+ 智能方仓，五大品类错峰入仓、全年连续生产。
        </p>
      </div>
      <!-- 底部两个按钮卡片 -->
      <div class="w-full grid grid-cols-2 gap-2 absolute bottom-0 left-0 z-10">
        <div style="background-color: rgba(255, 255, 255, 0.35)" @click="goPage('/product/2')"
          class="bg-opacity-35 py-4 pl-4 flex justify-between items-center text-white">
          <div>
            <p class="text-sm font-medium">蘑菇仓</p>
            <p class="text-[8px] whitespace-nowrap">Mushroom Growing Chamber</p>
          </div>
          <span class="text-xl mr-2">→</span>
        </div>
        <div style="background-color: rgba(255, 255, 255, 0.35)" @click="goPage('/product/1')"
          class="bg-opacity-35 py-4 pl-4 flex justify-between items-center text-white">
          <div>
            <p class="text-sm font-medium">菌菇</p>
            <p class="text-[8px]">Mushroom</p>
          </div>
          <span class="text-xl mr-2">→</span>
        </div>
      </div>
    </section>
    <!-- 2. 产品介绍区 -->
    <section class="py-16 md:max-w-[56%] max-w-[94%] mx-auto px-4">
      <h2 class="hidden md:block text-[44px] font-bold text-[#41B56F] text-center mb-4">
        让每一朵蘑菇，都在最佳环境中生长
      </h2>
      <p class="hidden md:block text-[#666666] text-center text-base mx-auto mb-16 leading-relaxed">
        三层组合策略：<br>
        高产主力保营收现金流 + 高附加值品种拉高利润 + 稳定品种均衡产能，多品类分散经营风险。
      </p>
      <div class="md:hidden text-[24px] font-bold text-[#333] mb-7 text-center">
        <img class="w-[18px] h-[18px]" src="@/assets/home/mb_icon.png" alt="" />
        <div class="mt-2">菌菇</div>
      </div>
      <!-- 3. 菌菇品类网格（2行4列） -->
      <div class="grid grid-cols-1 md:grid-cols-2 md:grid-cols-4 grid-cols-2 md:gap-8 gap-4 md:py-12">
        <!-- 品类卡片 1 -->

        <div
          class="mushroom-card md:px-5 px-2 md:pt-5 md:pb-10 py-4 flex flex-col items-center group rounded-xl transition-shadow,transition-border hover:shadow-[0_8px_20px_rgba(0,0,0,0.15)] hover:border-2"
          @click="goDetail(2)">
          <!-- 图片 + hover背景色 -->
          <div class="md:block hidden">
            <div
              class=" md:w-[180px] md:h-[180px] w-[90px] h-[90px] md:mb-4 bg-white rounded-2xl flex items-center justify-center group-hover:bg-[#F9F6F6] transition-all duration-300">
              <img src="@/assets/product/XZ_B.jpg" alt="秀珍菇" class="md:w-45 md:h-45 w-[100%] block group-hover:hidden">
              <img src="@/assets/product/XZ_A.jpg" alt="秀珍菇" class="md:w-45 md:h-45 w-[100%] hidden group-hover:block">
            </div>
          </div>

          <div class="md:hidden block">
            <div
              class=" md:w-[180px] md:h-[180px] w-[90px] h-[90px] md:mb-4 bg-white rounded-2xl flex items-center justify-center group-hover:bg-[#F9F6F6] transition-all duration-300">
              <img src="@/assets/product/XZ_A.jpg" alt="秀珍菇" class="md:w-45 md:h-45 w-[100%]">
            </div>
          </div>



          <h3 class="font-bold text-[#000] mb-2 w-full text-[14px] md:text-[20px]">秀珍菇</h3>

          <div class="flex items-center w-full">
            <p class="text-[#666] md:text-sm text-[8px] leading-relaxed flex-1">
              核心产量与现金流引擎。长周期仅 5-7 天、周转快
            </p>

            <!-- 箭头：默认一张，hover一张 -->
            <div class="mt-4 md:w-[34px] md:h-[34px] w-[18px] h-[18px]">
              <img src="@/assets/product/Component_18.png" class="w-full block group-hover:hidden">
              <img src="@/assets/product/Component_18_a.png" class="w-full hidden group-hover:block">
            </div>
          </div>
        </div>
        <div
          class="mushroom-card md:px-5 px-2 md:pt-5 md:pb-10 py-4 flex flex-col items-center group rounded-xl transition-shadow,transition-border hover:shadow-[0_8px_20px_rgba(0,0,0,0.15)] hover:border-2"
          @click="goDetail(3)">
          <!-- 图片 + hover背景色 -->
          <div class="md:block hidden">
            <div
              class="md:w-[180px] md:h-[180px] w-[90px] h-[90px] md:mb-4 bg-white rounded-2xl flex items-center justify-center group-hover:bg-[#F9F6F6] transition-all duration-300">
              <img src="@/assets/product/JE_B.jpg" alt="金耳" class="md:w-45 md:h-45 w-[100%] block group-hover:hidden">
              <img src="@/assets/product/JE_A.jpg" alt="金耳" class="md:w-45 md:h-45 w-[100%] hidden group-hover:block">
            </div>
          </div>
          <div class="md:hidden block">
            <div
              class="md:w-[180px] md:h-[180px] w-[90px] h-[90px] md:mb-4 bg-white rounded-2xl flex items-center justify-center group-hover:bg-[#F9F6F6] transition-all duration-300">
              <img src="@/assets/product/JE_A.jpg" alt="金耳" class="md:w-45 md:h-45 w-[100%]">
            </div>
          </div>


          <h3 class="font-bold text-[#000] mb-2 w-full text-[14px] md:text-[20px]">金耳</h3>

          <div class="flex items-center w-full">
            <p class="text-[#666] md:text-sm text-[8px] leading-relaxed flex-1">
              珍稀高附加值「菌中燕窝」。药食同源、多糖含量居首
            </p>

            <!-- 箭头：默认一张，hover一张 -->
            <div class="mt-4 md:w-[34px] md:h-[34px] w-[18px] h-[18px]">
              <img src="@/assets/product/Component_18.png" class="w-full block group-hover:hidden">
              <img src="@/assets/product/Component_18_a.png" class="w-full hidden group-hover:block">
            </div>
          </div>
        </div>
        <div
          class="mushroom-card md:px-5 px-2 md:pt-5 md:pb-10 py-4 flex flex-col items-center group rounded-xl transition-shadow,transition-border hover:shadow-[0_8px_20px_rgba(0,0,0,0.15)] hover:border-2"
          @click="goDetail(4)">
          <!-- 图片 + hover背景色 -->
          <div class="md:block hidden">
            <div
              class="md:w-[180px] md:h-[180px] w-[90px] h-[90px] md:mb-4 bg-white rounded-2xl flex items-center justify-center group-hover:bg-[#F9F6F6] transition-all duration-300">
              <img src="@/assets/product/WRJ_B.jpg" alt="舞茸菌" class="md:w-45 md:h-45 w-[100%] block group-hover:hidden">
              <img src="@/assets/product/WRJ_A.jpg" alt="舞茸菌" class="md:w-45 md:h-45 w-[100%] hidden group-hover:block">
            </div>
          </div>
          <div class="md:hidden block">
            <div
              class="md:w-[180px] md:h-[180px] w-[90px] h-[90px] md:mb-4 bg-white rounded-2xl flex items-center justify-center group-hover:bg-[#F9F6F6] transition-all duration-300">
              <img src="@/assets/product/WRJ_A.jpg" alt="舞茸菌" class="md:w-45 md:h-45 w-[100%]">
            </div>
          </div>


          <h3 class="font-bold text-[#000] mb-2 w-full text-[14px] md:text-[20px]">舞茸菌</h3>

          <div class="flex items-center w-full">
            <p class="text-[#666] md:text-sm text-[8px] leading-relaxed flex-1">
              珍稀食药用菌·出口日韩。周期约 30 天、多糖丰富
            </p>

            <!-- 箭头：默认一张，hover一张 -->
            <div class="mt-4 md:w-[34px] md:h-[34px] w-[18px] h-[18px]">
              <img src="@/assets/product/Component_18.png" class="w-full block group-hover:hidden">
              <img src="@/assets/product/Component_18_a.png" class="w-full hidden group-hover:block">
            </div>
          </div>
        </div>
        <div
          class="mushroom-card md:px-5 px-2 md:pt-5 md:pb-10 py-4 flex flex-col items-center group rounded-xl transition-shadow,transition-border hover:shadow-[0_8px_20px_rgba(0,0,0,0.15)] hover:border-2"
          @click="goDetail(1)">
          <!-- 图片 + hover背景色 -->
          <div class="md:block hidden">
            <div
              class="md:w-[180px] md:h-[180px] w-[90px] h-[90px] md:mb-4 bg-white rounded-2xl flex items-center justify-center group-hover:bg-[#F9F6F6] transition-all duration-300">
              <img src="@/assets/product/11_2.png" alt="香菇" class="md:w-45 md:h-45 w-[100%] block group-hover:hidden">
              <img src="@/assets/product/mushroom.png" alt="香菇"
                class="md:w-45 md:h-45 w-[100%] hidden group-hover:block">
            </div>
          </div>
          <div class="md:hidden block">
            <div
              class="md:w-[180px] md:h-[180px] w-[90px] h-[90px] md:mb-4 bg-white rounded-2xl flex items-center justify-center group-hover:bg-[#F9F6F6] transition-all duration-300">
              <img src="@/assets/product/mushroom.png" alt="香菇" class="md:w-45 md:h-45 w-[100%]">
            </div>
          </div>


          <h3 class="font-bold text-[#000] mb-2 w-full text-[14px] md:text-[20px]">香菇</h3>

          <div class="flex items-center w-full">
            <p class="text-[#666] md:text-sm text-[8px] leading-relaxed flex-1">
              稳产保供压舱石。技术成熟、抗逆性强
            </p>

            <!-- 箭头：默认一张，hover一张 -->
            <div class="mt-4 md:w-[34px] md:h-[34px] w-[18px] h-[18px]">
              <img src="@/assets/product/Component_18.png" class="w-full block group-hover:hidden">
              <img src="@/assets/product/Component_18_a.png" class="w-full hidden group-hover:block">
            </div>
          </div>
        </div>
        <div
          class="mushroom-card md:px-5 px-2 md:pt-5 md:pb-10 py-4 flex flex-col items-center group rounded-xl transition-shadow,transition-border hover:shadow-[0_8px_20px_rgba(0,0,0,0.15)] hover:border-2"
          @click="goDetail(5)">
          <!-- 图片 + hover背景色 -->
          <div class="md:block hidden">
            <img src="@/assets/product/SBG_B.jpg" alt="双孢菇" class="md:w-45 md:h-45 w-[100%] block group-hover:hidden">
            <img src="@/assets/product/SBG_A.jpg" alt="双孢菇" class="md:w-45 md:h-45 w-[100%] hidden group-hover:block">
          </div>
          <div class="md:hidden block">
            <div
              class="md:w-[180px] md:h-[180px] w-[90px] h-[90px] md:mb-4 bg-white rounded-2xl flex items-center justify-center group-hover:bg-[#F9F6F6] transition-all duration-300">
              <img src="@/assets/product/SBG_A.jpg" alt="双孢菇" class="md:w-45 md:h-45 w-[100%]">
            </div>

          </div>

          <h3 class="font-bold text-[#000] mb-2 w-full text-[14px] md:text-[20px]">双孢菇</h3>

          <div class="flex items-center w-full">
            <p class="text-[#666] md:text-sm text-[8px] leading-relaxed flex-1">
              大众消费基石品种。多潮次出菇、需求稳定
            </p>

            <!-- 箭头：默认一张，hover一张 -->
            <div class="mt-4 md:w-[34px] md:h-[34px] w-[18px] h-[18px]">
              <img src="@/assets/product/Component_18.png" class="w-full block group-hover:hidden">
              <img src="@/assets/product/Component_18_a.png" class="w-full hidden group-hover:block">
            </div>
          </div>
        </div>
        <div
          class="mushroom-card md:px-5 px-2 md:pt-5 md:pb-10 py-4 flex flex-col items-center group rounded-xl transition-shadow,transition-border hover:shadow-[0_8px_20px_rgba(0,0,0,0.15)] hover:border-2"
          @click="goDetail(6)">
          <!-- 图片 + hover背景色 -->
          <div class="md:block hidden">
            <img src="@/assets/product/PG_B.jpg" alt="平菇" class="md:w-45 md:h-45 w-[100%] block group-hover:hidden">
            <img src="@/assets/product/PG_A.jpg" alt="平菇" class="md:w-45 md:h-45 w-[100%] hidden group-hover:block">
          </div>
          <div class="md:hidden block">
            <div
              class="md:w-[180px] md:h-[180px] w-[90px] h-[90px] md:mb-4 bg-white rounded-2xl flex items-center justify-center group-hover:bg-[#F9F6F6] transition-all duration-300">
              <img src="@/assets/product/PG_A.jpg" alt="平菇" class="md:w-45 md:h-45 w-[100%]">
            </div>

          </div>

          <h3 class="font-bold text-[#000] mb-2 w-full text-[14px] md:text-[20px]">平菇</h3>

          <div class="flex items-center w-full">
            <p class="text-[#666] md:text-sm text-[8px] leading-relaxed flex-1">
              高产稳供基础款。适应性强、出菇快、供货体量足
            </p>

            <!-- 箭头：默认一张，hover一张 -->
            <div class="mt-4 md:w-[34px] md:h-[34px] w-[18px] h-[18px]">
              <img src="@/assets/product/Component_18.png" class="w-full block group-hover:hidden">
              <img src="@/assets/product/Component_18_a.png" class="w-full hidden group-hover:block">
            </div>
          </div>
        </div>
         <div
          class="mushroom-card md:px-5 px-2 md:pt-5 md:pb-10 py-4 flex flex-col items-center group rounded-xl transition-shadow,transition-border hover:shadow-[0_8px_20px_rgba(0,0,0,0.15)] hover:border-2"
          @click="goDetail(7)">
          <!-- 图片 + hover背景色 -->
          <div class="md:block hidden">
            <img src="@/assets/product/XWG_B.jpg" alt="蟹味菇" class="md:w-45 md:h-45 w-[100%] block group-hover:hidden">
            <img src="@/assets/product/XWG_A.jpg" alt="蟹味菇" class="md:w-45 md:h-45 w-[100%] hidden group-hover:block">
          </div>
          <div class="md:hidden block">
            <div
              class="md:w-[180px] md:h-[180px] w-[90px] h-[90px] md:mb-4 bg-white rounded-2xl flex items-center justify-center group-hover:bg-[#F9F6F6] transition-all duration-300">
              <img src="@/assets/product/XWG_A.jpg" alt="蟹味菇" class="md:w-45 md:h-45 w-[100%]">
            </div>

          </div>

          <h3 class="font-bold text-[#000] mb-2 w-full text-[14px] md:text-[20px]">蟹味菇</h3>

          <div class="flex items-center w-full">
            <p class="text-[#666] md:text-sm text-[8px] leading-relaxed flex-1">
              鲜香特色菌菇。出菇整齐、品相佳溢价空间好
            </p>

            <!-- 箭头：默认一张，hover一张 -->
            <div class="mt-4 md:w-[34px] md:h-[34px] w-[18px] h-[18px]">
              <img src="@/assets/product/Component_18.png" class="w-full block group-hover:hidden">
              <img src="@/assets/product/Component_18_a.png" class="w-full hidden group-hover:block">
            </div>
          </div>
        </div>
         <div
          class="mushroom-card md:px-5 px-2 md:pt-5 md:pb-10 py-4 flex flex-col items-center group rounded-xl transition-shadow,transition-border hover:shadow-[0_8px_20px_rgba(0,0,0,0.15)] hover:border-2"
          @click="goDetail(8)">
          <!-- 图片 + hover背景色 -->
          <div class="md:block hidden">
            <img src="@/assets/product/XBG_B.jpg" alt="杏鲍菇" class="md:w-45 md:h-45 w-[100%] block group-hover:hidden">
            <img src="@/assets/product/XBG_A.jpg" alt="杏鲍菇" class="md:w-45 md:h-45 w-[100%] hidden group-hover:block">
          </div>
          <div class="md:hidden block">
            <div
              class="md:w-[180px] md:h-[180px] w-[90px] h-[90px] md:mb-4 bg-white rounded-2xl flex items-center justify-center group-hover:bg-[#F9F6F6] transition-all duration-300">
              <img src="@/assets/product/XWG_A.jpg" alt="杏鲍菇" class="md:w-45 md:h-45 w-[100%]">
            </div>

          </div>

          <h3 class="font-bold text-[#000] mb-2 w-full text-[14px] md:text-[20px]">杏鲍菇</h3>

          <div class="flex items-center w-full">
            <p class="text-[#666] md:text-sm text-[8px] leading-relaxed flex-1">
              肉质肥厚、口感脆嫩。适合规模化标准化生产
            </p>

            <!-- 箭头：默认一张，hover一张 -->
            <div class="mt-4 md:w-[34px] md:h-[34px] w-[18px] h-[18px]">
              <img src="@/assets/product/Component_18.png" class="w-full block group-hover:hidden">
              <img src="@/assets/product/Component_18_a.png" class="w-full hidden group-hover:block">
            </div>
          </div>
        </div>
      </div>

      <!-- 了解更多按钮 -->
      <!-- <div class="hidden md:block text-center">
        <div class="mt-8 text-white w-[150px] h-[30px] text-center bg-[#41B56F] leading-[1.8] mx-auto">了解更多</div>
      </div> -->
    </section>
  </div>
</template>

<script>
export default {
  name: "Product1Page",
  methods: {
    goDetail(id) {
      this.$router.push(`/product1/detail?id=${id}`);
    },

    goPage(path) {
      this.$router.push(path);
    },
  }
};
</script>

<style scoped>
/* 卡片hover微动效 */
.mushroom-card {
  transition: transform 0.3s ease;
}

.mushroom-card:hover {
  transform: translateY(-5px);
}
</style>